// extracted by mini-css-extract-plugin
export default {"brandName":"BrandName_brandName__mIaat"};